import React, { useEffect, useState } from "react";
import "./BrandImages.css";
import Icons from "../../../../Config/Images"; // Static images from your config
import CustomImageComponent from "../../CustomComponents/CustomImageComponent";
import { useNavigate } from "react-router-dom";

const BrandImages = ({ data }) => {
  const navigate = useNavigate();
  // const brandImages = [
  //   Icons.brandImage,
  //   Icons.brandImage,
  //   Icons.brandImage,
  //   Icons.brandImage,
  //   Icons.brandImage,
  //   Icons.brandImage,
  //   Icons.brandImage
  // ]; // Static array of images

  const [brandImages, setBrandImages] = useState([]);

  useEffect(() => {
    if (data) {
      setBrandImages(data);
    }
  }, [data]);

  const handleBrandImageClick = (brand) => {
    navigate("/categories-by-brand", {
      state: { fromBrands: true, brand },
    });
  };
  return (
    <div className="brandImages">
      {brandImages?.length > 0 ? (
        brandImages?.map((image, index) => (
          <div
            key={index}
            style={{ cursor: "pointer" }}
            onClick={() => handleBrandImageClick(image)}
            className="imgDiv"
          >
            <CustomImageComponent
              src={`${image?.brand_image_url}`}
              alt=""
            />
          </div>
        ))
      ) : (
        <p>No brand images available</p>
      )}
    </div>
  );
};

export default BrandImages;
